const getLoadingStatus = (rootState) => rootState.subscriptions.isLoaded;

export default getLoadingStatus;
